// src/components/admin/VisitorStats.js
import React from 'react';
import { FaChartLine } from 'react-icons/fa'; // Icon for stats

const VisitorStats = () => (
  <div className="bg-white p-6 rounded-lg shadow-md flex items-center justify-between">
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-2">Website Visitors</h3>
      {/* Removed the static approximate number */}
      <p className="text-sm text-gray-500">
        For real-time and detailed analytics,
        <a
          href="https://analytics.google.com/" // Link to Google Analytics dashboard
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline ml-1"
        >
          click to see number of visitors
        </a>.
      </p>
      <p className="text-xs text-gray-400 mt-1">
        (Direct integration requires complex backend setup for secure API access.)
      </p>
    </div>
    <FaChartLine className="text-purple-400 text-4xl" />
  </div>
);

export default VisitorStats;